import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2b8bb530"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    type: "button",
    class: "base"
};
import DynamicIcon from '@apparatix/icons/DynamicIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'IconButton',
    props: {
        iconName: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("button", _hoisted_1, [
                _createVNode(DynamicIcon, { name: _ctx.iconName }, null, 8, ["name"])
            ]));
        };
    }
});
